module.exports = __webpack_public_path__ + "img/home2.80be1e48.jpg";